import { flexPoolService } from 'ogp/services';
import { useMutation } from 'react-query';

export type FlexWorkerFlexPoolsData = {
  flexWorkerId: string;
  flexPoolsToRemove: string[];
  flexPoolsToAdd: string[];
  companyId?: string;
};

export const useOgpUpdateFlexWorkerFlexPools = () => {
  const mutationFn = async (queryData: FlexWorkerFlexPoolsData) => {
    const { flexWorkerId, flexPoolsToAdd, flexPoolsToRemove } = queryData;

    await flexPoolService.updateFlexWorkerFlexPools(flexWorkerId, {
      flexPoolsToAdd,
      flexPoolsToRemove,
    });
  };

  return useMutation(mutationFn);
};
